<template>
  <b-modal
    id="myiddup"
    ref="modal"
    title="중복관리(sen)"
    size="xl"
    scrollable
    @show="resetModal"
    @ok="handleOk"
    v-bind:hide-footer="true"
  >
    <b-container fluid class="bod">
      <div
        v-if="simlist.length == 0"
        style="
          min-height: 480px;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <h4 style="color: blue">{{ result_txt }}</h4>
      </div>
      <div style="min-height: 480px" v-else>
        <div class="buttons">
          <b-button @click="prev">이전</b-button>
          <b-button @click="simconfirm" variant="danger">
            {{ notitext }}
          </b-button>
          <b-button @click="next">다음</b-button>
        </div>
        <b-row class="drow" style="margin-top: 15px">
          <b-col cols="2">대상 QCODE </b-col>
          <b-col>
            <h4>{{ target_qcode }}</h4>
            <h5>{{ plain_jimun_idf }}</h5>
            <h5 style="color: crimson">{{ tquestionmeta.qcode }}</h5>
          </b-col>
        </b-row>

        <b-row class="drow">
          <b-col cols="2">번호 </b-col>
          <b-col>
            <h5>
              {{ pos + 1 }}
            </h5>
          </b-col>
        </b-row>

        <b-row class="drow">
          <b-col cols="2"> 문제 </b-col>
          <b-col>{{ tquestion.title }} </b-col>
        </b-row>
      </div>
    </b-container>
  </b-modal>
</template>

<script>
import axios from "axios";
import * as _ from "lodash";
const SERVER_URL = `${process.env.VUE_APP_SERVER_URL}`;
export default {
  props: ["main_metaid"],

  mounted() {
    let $this = this;
    this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
      $this.result_txt = "검색중";
      $this.tquestionmeta = {};
      $this.tquestion = {};
      $this.simlist = [];
      $this.tid = null;

      //todo: 이곳에  std_type 별 다른방식으로 불려야함.
      let val = "0000";
      let url = "";

      let question_id = this.$store.state.questionform.id;

      if (this.std_type != 2) {
        url = `${SERVER_URL}/api/question_bank/titlesim/${val}?main_metaid=${this.mid}`;
        axios.get(url).then((resp) => {
          let data = resp.data;

          if (data.length == 0 || data == null) {
            this.result_txt = "내용없음";
          }

          $this.simlist = data;
          if (this.std_type == 1) {
            $this.tid = $this.simlist[0].target_qid;
          } else {
            $this.tid = $this.simlist[0].target_metaid;
          }

          this.loadQuestion();
        });
      } else {
        // alert(question_id);
        url = `${SERVER_URL}/api/question_bank/titlesim2/${val}?question_id=${question_id}`;
        axios.get(url).then((resp) => {
          let data = resp.data;
          if (data.length == 0 || data == null) {
            this.result_txt = "내용없음";
          }

          $this.simlist = data;
          $this.tid = $this.simlist[0].target_qid;
          this.loadQuestion();
        });
      }
    });
  },

  computed: {
    mid() {
      return this.$store.state.questionmeta.id;
    },
    qcode() {
      return this.$store.state.questionmeta.qcode;
    },
    std_type() {
      return this.$store.state.questionmeta.std_type;
    },
    plain_jimun_idf() {
      return this.$store.state.questionmeta.plain_jimun_idf;
    },
    plain_jimun_subject_text() {
      try {
        let cd = this.tquestionmeta.plain_jimun_subject;
        let jimun_subject_options = this.$store.state.jimun_subject_options;
        let k = _.find(jimun_subject_options, function (o) {
          return o.value == cd;
        });
        return k.text;
      } catch {
        return "";
      }
    },
    plain_jimun_level() {
      return "level" + this.tquestionmeta.plain_jimun_level;
    },

    target_qcode() {
      return this.simlist[this.pos].target_qcode;
    },
  },
  data() {
    return {
      simlist: [],
      pos: 0,
      tid: null,
      tquestionmeta: {},
      notitext: "설정",
      tquestion: {},
      result_txt:'',
    };
  },

  watch: {
    plain_jimun_idf: {
      immediate: true,
      handler(val, old) {
        if (val != null && val != "") {
          console.log("dummy");
        } else {
          console.log("else statement");
        }
      },
    },
  },

  methods: {
    resetModal() {},
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmit();
    },
    async handleSubmit() {},
    prev() {
      if (this.pos > 0) {
        this.pos--;
        if (this.std_type != 2) {
          // this.tid = this.simlist[this.pos].target_metaid;
          if (this.std_type == 1) {
            this.tid = this.simlist[this.pos].target_qid;
          } else {
            this.tid = this.simlist[this.pos].target_metaid;
          }
        } else {
          this.tid = this.simlist[this.pos].target_qid;
        }

        this.loadQuestion();
      } else {
        alert("첫페이지 입니다.");
      }
    },
    next() {
      if (this.pos < this.simlist.length - 1) {
        this.pos++;
        if (this.std_type != 2) {
          // this.tid = this.simlist[this.pos].target_metaid;

          if (this.std_type == 1) {
            this.tid = this.simlist[this.pos].target_qid;
          } else {
            this.tid = this.simlist[this.pos].target_metaid;
          }
        } else {
          this.tid = this.simlist[this.pos].target_qid;
        }

        this.loadQuestion();
      } else {
        alert("마지막페이지 입니다.");
      }
    },
    simconfirm() {
      console.log(this.tquestionmeta.id);
      let _id = this.tquestionmeta.id;
      if (this.std_type != 2) {
        let url = `${SERVER_URL}/api/question_bank/metasim`;

        // alert(this.tquestion.meta_id);
        let t_id = parseInt(this.tquestion.meta_id); // 구문분석 작업하면서 수정
        axios
          .post(url, {
            main_metaid: this.mid,
            target_metaid: t_id,
          })
          .then((resp) => {
            console.log("update");
          });

        if (this.notitext === "연관성 해제") {
          this.notitext = "연관성 설정";
        } else {
          this.notitext = "연관성 해제";
        }
      } else {
        let question_id = this.$store.state.questionform.id;
        let url = `${SERVER_URL}/api/question_bank/metasim2`;
        let $this = this;
        axios
          .post(url, {
            main_qid: question_id,
            target_qid: $this.tid,
          })
          .then((resp) => {
            console.log("update");
          });

        if (this.notitext === "연관성 해제") {
          this.notitext = "연관성 설정";
        } else {
          this.notitext = "연관성 해제";
        }
      }
    },

    loadQuestion() {
      let $this = this;
      if (this.std_type != 2) {
        let question_id = this.$store.state.questionform.id;
        let kkk = this.tid;
        // if (this.std_type == 2) {
        //   kkk = question_id;
        // }

        // let url = `${SERVER_URL}/question/${kkk}`;
        let url = `${SERVER_URL}/questiononly/${kkk}`;

        axios.get(url).then((resp) => {
          let question = resp.data;
          // this.tquestionmeta = resp.data.questionmeta;
          this.tquestion = question;
          console.log(this.tquestion);
          let mt_id = question.meta_id;
          let url2 = `${SERVER_URL}/api/question_bank/matchsim?main_metaid=${$this.mid}&target_metaid=${mt_id}`;
          axios.get(url2).then((resp2) => {
            console.log(resp2.data);
            if (resp2.data > 0) {
              $this.notitext = "연관성 해제";
            } else {
              $this.notitext = "연관성 설정";
            }
          });
        });
      } else {
        // tid has question_id
        console.log(this.$store.state.questionform);
        let question_id = this.$store.state.questionform.id;

        let url = `${SERVER_URL}/questiononly/${this.tid}`;
        axios.get(url).then((resp) => {
          let question = resp.data;
          // this.tquestionmeta = resp.data.questionmeta;
          this.tquestion = question;

          let url2 = `${SERVER_URL}/api/question_bank/matchsim2?main_qid=${question_id}&target_qid=${this.tid}`;
          axios.get(url2).then((resp2) => {
            console.log(resp2.data);
            if (resp2.data > 0) {
              $this.notitext = "연관성 해제";
            } else {
              $this.notitext = "연관성 설정";
            }
          });
        });
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.drow {
  border-bottom: 1px solid lightgray;
  padding: 8px 0 8px 0;
}
.buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
